import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const ForgotPasswordModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "ForgotPasswordModalContainer" */
      './ForgotPasswordModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
